export default "__VITE_ASSET__xD2zB1Qo__"